"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, Clock, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourConsultationToday() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="154777" id="ready-for-a-consultation" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/90 via-primary/60 to-background z-0" />
      
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_0%,transparent_100%)] z-0" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Badge variant="outline" className="mb-8 border-accent/20 bg-accent/10 text-accent-foreground backdrop-blur-md px-4 py-1.5 text-sm rounded-full shadow-sm">
          <Clock className="w-4 h-4 mr-2 inline-block" />
          No-Pressure Consultation
        </Badge>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif tracking-tight text-white mb-6 max-w-4xl">
          Ready for a Consultation?
        </h2>

        <p className="text-lg md:text-xl font-sans text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          Experience affordable, quality dental care at Smart Choice Dentures & Implants. 
          Our El Monte specialists are ready to help you achieve the confident smile you deserve.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 w-full sm:w-auto">
          {}
          <div className="relative inline-flex w-full sm:w-auto group">
            <div className="absolute inset-0 bg-white rounded-full animate-ping opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
            <Button asChild size="lg" className="relative w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-full shadow-lg transition-transform duration-300 hover:scale-105">
              <Link to="#">
                <SafeHydrate><Calendar className="w-5 h-5 mr-2" /></SafeHydrate>
                Schedule Now
              </Link>
            </Button>
          </div>

          {}
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-white/30 text-white hover:bg-white/10 hover:text-white text-lg h-14 px-8 rounded-full backdrop-blur-sm transition-all duration-300">
            <Link to="tel:626-268-5990">
              <Phone className="w-5 h-5 mr-2" />
              626-268-5990
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}